export default "__VITE_ASSET__CnvPZuj___"